import { ShowMessage } from "./alert";
import { API_ROOT } from "./config";
import axios from "axios";
import { getStorage } from "./storage";

export const mainApi = async (opts) => {
  let config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getStorage("token")}`,
    },
    baseURL: API_ROOT,
    ...opts,
  };
  try {
    const response = await axios(config);

    return response.data;
  } catch (error) {
    if (error.response?.status === 400)
      return ShowMessage(error.response?.data);
    if (error.response?.status === 401)
      return ShowMessage(error.response?.data);
    if (error.response?.status === 403) window.location = "/login";

    throw new Error(error);
  }
};

export const timeOut = (ms = 1000) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
